import React, { useState, useEffect, useContext } from 'react';
import { Select } from '@tencent/spaui';
import _ from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import { PageUtil } from '../../../utils/PageUtil';
import { UserInfoDialogContext } from '../../../store/context/userInfoDialogContext';

// 做个缓存避免选择组件会出现“突然消失一下”的现象
function getCorpListCacheKey() {
  return `corpList-${_.get(window, 'pageProps.uid')}`;
}
function getCorpListCache() {
  let corpList = [];
  try {
    const corpListJSON = window.sessionStorage.getItem(getCorpListCacheKey());
    corpList = JSON.parse(corpListJSON) || [];
  } catch (e) {
    corpList = [];
  }
  console.log('chached list', corpList);
  return corpList;
}

function updateCorpListCache(corpList) {
  const corpListJSON = JSON.stringify(corpList);
  window.sessionStorage.setItem(getCorpListCacheKey(), corpListJSON);
}

const CorpSelectorInner = (props) => {
  const context = useContext(UserInfoDialogContext);
  const [appList, setAppList] = useState(getCorpListCache());
  const [currentApp, setApp] = useState(window.pageProps.corpId || '');

  useEffect(() => {
    if (window.pageProps.source !== 'qw' && !!currentApp) {
      RPCFactory.qwBoard
        .corpList()
        .done((data) => {
          if (_.isArray(data.list) && data.list.length > 0) {
            updateCorpListCache(data.list);
            setAppList(data.list);
            if (currentApp === '') {
              setApp(data.list[0].corpId);
            }
          }
        })
        .fail((status, msg) => {
          alert(msg ? msg : '请求失败');
        });
    }
  }, []);

  const selectCorp = (value) => {
    window.pageProps.corpId = value;
    // localStorage.setItem(`corpId ${window.pageProps.uid}`, value);
    setApp(value);
    const callback = () => context.setRouter(PageUtil.getAuthedRoutes());
    // 调用init函数
    PageUtil.initWithCallback(callback);
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return window.pageProps.source != 'qw' && !!currentApp && appList.length ? (
    <div className="page-pool">
      <div className="a-tabs-head-right" style={{ top: '-55px' }}>
        <div className="timely-tips">
          <span style={{ display: 'block', padding: '2px 4px 0 0' }}>选择企业</span>
          <Select
            valueFieldName="corpId"
            labelFieldName="corpName"
            data={appList}
            value={currentApp}
            onChange={(e, value) => {
              selectCorp(value);
            }}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export const CorpSelector = React.memo(CorpSelectorInner);
